//node modules
import {useEffect} from "react";

//global variables
//callback functions
import {useAppState} from "../../context/state";
import {useNavigate} from "react-router-dom";
import {useValidateForm} from "../../global/callback functions/forms/validate/validate";
import {fbLogin} from "../../global/callback functions/autentication/fb_signIn";


//import Components
import {Button, Form, FormGroup, FormText, Input, Label} from "reactstrap";
import PageWrapper from "../../layouts/components/PageWrapper";
import ContentWrapper from "../../layouts/components/ContentWrapper";

//validators
import {loginSchema} from "../../global/callback functions/autentication/auth_schema";


export default function LoginUser() {
  const {appState, setAppState} = useAppState();
  const navigate = useNavigate();
  const {formValues, errors, handleFormSubmit, reValidate, handleFieldChange} = useValidateForm(
    loginSchema,
    {username: "", password: ""}
  );


  //runs a revalidation everytime user updates their inputs
  useEffect(() => {
    reValidate();
  }, [formValues, reValidate]);


  function setProcessing(state: boolean) {
    setAppState({
      ...appState,
      processing: state
    });
  }

  return (
    <>
      <PageWrapper page={"login"}>
        <ContentWrapper className={"login-form"}>
          <div>
            <Form onSubmit={event => handleFormSubmit((data) => {
              event.preventDefault();

              setProcessing(true);
              fbLogin(data)
                .then(() => {
                  navigate("/")
                });
            })}>

              <FormGroup>
                <Label className={"required"} htmlFor={"username"}>Epost / mobilnummer</Label>
                <Input
                  name={"username"}
                  type="text"
                  placeholder=""
                  onChange={handleFieldChange}
                  required
                />
                {errors?.username && <FormText className={"form-error"}>{errors.username}</FormText>}
              </FormGroup>

              <FormGroup>
                <Label className={"required"} htmlFor={"password"}>Passord</Label>
                <Input
                  name={"password"}
                  type="password"
                  onChange={handleFieldChange}
                  required
                />
                {errors?.password && <FormText className={"form-error"}>{errors.password}</FormText>}
              </FormGroup>


              <FormGroup className={"form_action"}>
                <Button className={"form-action loginBtn"} type="submit">Login</Button>
              </FormGroup>
            </Form>
          </div>
        </ContentWrapper>
      </PageWrapper>
    </>
  )
}
